module.exports = __webpack_public_path__ + "static/media/iconOne.6529c011.svg";